import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset scroll position on route change.
 *
 * Two scroll viewports to cover:
 *  - **Web**: html+body scrolls; `window.scrollTo` handles it.
 *  - **Capacitor native** (html.cap-locked, see styles/index.css): html+body
 *    are pinned, scroll lives in #root → `window.scrollTo` is a no-op there.
 *
 * We call both blindly. Each is idempotent and cheap; whichever isn't the
 * active scroller no-ops without side effects.
 *
 * Doesn't touch internal scrollers like AppShell's `.flex-1.overflow-y-auto`
 * — those are per-page and their own components handle their reset on mount.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const root = document.getElementById('root');
    if (root) root.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;